import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import './styles/dashboard.css';
import './styles/portal-theme.css';
import './styles/portal-modern.css';
import App from './App';
import retireServiceWorker from './utils/retireServiceWorker';

retireServiceWorker();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
